interface ToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  disabled?: boolean;
}

export function Toggle({ checked, onChange, label, disabled }: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`flex h-[27px] w-[46px] shrink-0 items-center rounded-full p-[3px] transition-colors
                  disabled:opacity-50 ${checked ? 'justify-end bg-conduril' : 'justify-start bg-[#d5d8e2]'}`}
    >
      <span className="h-[21px] w-[21px] rounded-full bg-white shadow-sm" />
    </button>
  );
}
